module.exports = __webpack_public_path__ + "img/chevy-multivehicle.59c0e3fd.jpg";